import React, {FC} from 'react';
import { style } from 'typestyle';
import { ADALONG_COLORS } from '@src/styles';
import { ActionButton } from '@src/components/ActionButton';

interface ConfirmationOverlayProps {
  message: string;
  onCancel: () => void;
  onConfirm: () => void;
  cancelText?: string;
  confirmText?: string;
}

/**
 * Reusable confirmation overlay component with a message and two action buttons
 */
export const ConfirmationOverlay: FC<ConfirmationOverlayProps> = ({
  message,
  onCancel,
  onConfirm,
  cancelText = 'CANCEL',
  confirmText = 'CONFIRM'
}) => {
  return (
    <div className={overlayStyle}>
      <p className={messageStyle}>
        {message}
      </p>
      <div className={buttonsContainerStyle}>
        <ActionButton 
          onClick={onCancel} 
          variant="transparent"
          size='small'
        >
          {cancelText}
        </ActionButton>
        <ActionButton 
          onClick={onConfirm} 
          variant="blue"
          size='small'
        >
          {confirmText}
        </ActionButton>
      </div>
    </div>
  );
};

const overlayStyle = style({
  backgroundColor: ADALONG_COLORS.DARK_BLACK,
  padding: '15px',
  borderRadius: '5px',
  textAlign: 'center',
  maxWidth: '100%'
});

const messageStyle = style({
  fontSize: '14px',
  lineHeight: '1.5',
  margin: '0 0 15px 0',
});

const buttonsContainerStyle = style({
  display: 'flex',
  justifyContent: 'center',
  gap: '10px'
});
